module.exports = "query ($countryId: Int!, $term: String) {\n    getCitiesList(countryId: $countryId, term: $term) {\n        id\n        name\n    }\n}\n"